import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';

import PartnerTypeahead from 'modules/_shared/components/PartnerTypeahead';
import InputError from 'modules/_shared/components/InputError';

import { EMAIL_PATTERN } from 'constants/defaultConstants';

import { useAddPartnerModal } from '../context/AddPartnerModalContext';
import PersonTypeSection from './PersonTypeSection';

const AddPartnerModalBody: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useAddPartnerModal();

  return (
    <Modal.Body>
      <div className="nk-modal">
        <div className="row mb-4">
          <div className="col">
            <PersonTypeSection />
            <div className="form-group">
              <label className="form-label" htmlFor="partner-name">
                {t('PartnerNameSociety')}
              </label>

              <PartnerTypeahead
                naturalPerson={data.naturalPerson}
                onChangeName={actions.onChangeName}
                onChangeCif={actions.onChangeCif}
                onChangeEmail={actions.onChangeEmail}
                placeholder={t('NameAndSurname')}
              />
            </div>
          </div>
        </div>

        <div className="form-group mt-4">
          <label className="form-label" htmlFor="partner-cif">
            {t('FiscalIdentification')}
          </label>
          <div className="form-control-wrap">
            <div className="form-icon form-icon-left">
              <em className="icon ni ni-cc-alt2" />
            </div>
            <input
              type="text"
              name="partner-cif"
              className="form-control form-control-lg"
              value={data.cif}
              onChange={actions.handleChangeCif}
              placeholder={t('EnterTheCifOrNif')}
              required
            />
          </div>
        </div>

        <div className="form-group mt-4">
          <label className="form-label" htmlFor="partner-email">
            {t('Email')}
          </label>
          <div className="form-control-wrap">
            <div className="form-icon form-icon-left">
              <em className="icon ni ni-mail" />
            </div>
            <input
              type="email"
              name="partner-email"
              className="form-control form-control-lg"
              placeholder={t('EmailOfTheNewRepresentant')}
              value={data.email}
              onChange={actions.handleChangeEmail}
              pattern={EMAIL_PATTERN}
            />
          </div>
          {!data.isEmailValid && (
            <InputError errorMessage={t('InvalidEmail')} />
          )}
        </div>
      </div>
    </Modal.Body>
  );
};

export default AddPartnerModalBody;
